// Categorías y preguntas frecuentes del Centro de Soporte.
// Cada categoría agrupa preguntas con respuesta predefinida; si el usuario
// no encuentra su problema aquí, el widget lo deriva al chat con el asistente IA.
import { T } from './Translate';

const supportFaqData = [
  {
    id: 'cuenta',
    icon: '👤',
    label: <T>Cuenta y Perfil</T>,
    questions: [
      {
        q: <T>¿Cómo restablezco mi contraseña?</T>,
        a: <T>Ve a la pantalla de inicio de sesión y haz clic en "Olvidé mi contraseña". Recibirás un correo con instrucciones para crear una nueva contraseña.</T>,
      },
      {
        q: <T>¿Cómo actualizo la información de mi perfil?</T>,
        a: <T>Una vez que hayas iniciado sesión, entra a tu perfil desde tu foto o nombre de usuario en la barra de navegación superior. Desde allí puedes editar tus datos personales y tu foto.</T>,
      },
      {
        q: <T>¿Cómo cierro sesión o cambio de cuenta?</T>,
        a: <T>Abre el menú de tu cuenta (tu foto en la barra inferior) y toca "Cerrar sesión". Luego puedes iniciar sesión con otra cuenta desde la pantalla de Login.</T>,
      },
    ],
  },
  {
    id: 'suscripcion',
    icon: '💳',
    label: <T>Suscripción y Pagos</T>,
    questions: [
      {
        q: <T>¿Qué planes de suscripción existen?</T>,
        a: <T>Navegar por la app es gratis. Para publicar necesitas un plan: la primera vez puedes probar gratis 30 días, sin tarjeta, y después elegir Básico, Profesional o Premium, que son pagos y tienen modalidad mensual o anual. Básico: 3 ofertas, 2 eventos, 1 viaje y 1 auto por mes, y 10 productos por tienda. Profesional: 10 ofertas, 5 eventos, 3 viajes y 3 autos por mes, y 50 productos por tienda. Premium: publicaciones y productos ilimitados.</T>,
      },
      {
        q: <T>¿Cómo contrato o cambio mi plan?</T>,
        a: <T>Abre el menú de tu cuenta y entra a "Suscripciones", elige el plan y la frecuencia (mensual/anual) que prefieras, y confirma el pago. Si ya tienes un plan activo, por ahora no se puede cambiar directamente: cancélalo desde esa misma pantalla, sigues con tu plan hasta que termine el período pagado y después eliges el nuevo.</T>,
      },
      {
        q: <T>¿Qué métodos de pago aceptan?</T>,
        a: <T>Los pagos de suscripción se procesan a través de PayPal. También puedes pagar publicaciones puntuales con tarjeta a través de PayPal. Los pedidos de comida y súper se pagan aparte, en efectivo o por transferencia al local.</T>,
      },
      {
        q: <T>¿Cómo cancelo mi suscripción?</T>,
        a: <T>Desde la sección "Suscripciones" puedes cancelarla: esto actualiza tu estado a "Cancelada" y detiene los pagos automáticos en PayPal. La cancelación detiene los cargos futuros pero no genera un reembolso automático del período ya facturado: sigues con tu plan hasta que ese período termine. Si cancelas el mes gratis, termina enseguida.</T>,
      },
    ],
  },
  {
    id: 'reembolsos',
    icon: '💸',
    label: <T>Reembolsos</T>,
    questions: [
      {
        q: <T>¿Puedo pedir un reembolso de mi suscripción?</T>,
        a: <T>Sí, si acabas de suscribirte puedes pedir el reembolso completo dentro de los primeros 7 días desde la activación, siempre que no hayas usado las funciones de publicación de forma extensiva. También aplican reembolsos por fallas del servicio o renovaciones no deseadas.</T>,
      },
      {
        q: <T>¿Cómo solicito un reembolso?</T>,
        a: <T>Escríbenos a support@notiline.com o por esta misma sección de Soporte, indicando tu nombre, correo, ID de suscripción, fecha del cargo y el motivo. Revisamos las solicitudes en un plazo de 5 días hábiles.</T>,
      },
      {
        q: <T>¿Dónde veo la política completa de reembolsos?</T>,
        a: <T>Puedes consultar todos los detalles y plazos en la pantalla "Política de Reembolsos", disponible desde el menú de tu cuenta.</T>,
      },
    ],
  },
  {
    id: 'publicaciones',
    icon: '📢',
    label: <T>Ofertas, Eventos, Autos y Lugares</T>,
    questions: [
      {
        q: <T>¿Cómo publico una oferta o cupón?</T>,
        a: <T>Usa el botón de publicar (el ícono "+" de la barra inferior) y selecciona "Ofertas". Necesitas una suscripción activa para publicar.</T>,
      },
      {
        q: <T>¿Cómo publico un evento?</T>,
        a: <T>Desde el botón de publicar selecciona "Eventos", completa título, descripción, categoría, fecha y una foto o video, y confírmalo. Aparecerá en la sección de Eventos, donde los usuarios pueden marcar "Asistiré". Si el evento es pago, también pueden comprar la entrada con PayPal: el pago va directo al organizador.</T>,
      },
      {
        q: <T>¿Cómo publico un auto en venta?</T>,
        a: <T>Desde el botón de publicar selecciona "Autos", carga las fotos, precio, marca y condición (Nuevo, Usado o Para reparar). Tu publicación aparecerá en la sección Autos, donde otros usuarios pueden filtrar por condición y marca.</T>,
      },
      {
        q: <T>¿Cómo publico una propiedad o viaje?</T>,
        a: <T>Desde el botón de publicar selecciona "Propiedades", elige el tipo (alojamiento, compra o alquiler), la región y agrega fotos, ubicación y precio. Quedará visible en la sección Lugares, donde se puede explorar por región desde un mapa interactivo.</T>,
      },
      {
        q: <T>¿Cuántas publicaciones puedo hacer por mes?</T>,
        a: <T>Depende de tu plan de suscripción: el plan Básico tiene límites mensuales por categoría, el Profesional permite más, y el Premium permite publicaciones ilimitadas en todas las categorías.</T>,
      },
    ],
  },
  {
    id: 'tiendas',
    icon: '🏬',
    label: <T>Tiendas</T>,
    questions: [
      {
        q: <T>¿Cómo creo mi tienda?</T>,
        a: <T>Toca el botón "+" y selecciona "Tiendas". Completa el nombre, descripción, dirección (se ubica en el mapa automáticamente), horarios, WhatsApp y tu correo de PayPal para recibir los pagos. Crear una tienda tiene un costo único de USD 5 con PayPal, también durante el mes gratis.</T>,
      },
      {
        q: <T>¿Cuántos productos puedo publicar en mi tienda?</T>,
        a: <T>El límite por tienda depende de tu plan: hasta 10 productos en el Básico y durante el mes gratis, hasta 50 en el Profesional e ilimitados en el Premium.</T>,
      },
      {
        q: <T>¿Cómo edito o elimino un producto de mi tienda?</T>,
        a: <T>Entra a "Mis Tiendas", selecciona la tienda y luego el producto que quieres editar o eliminar desde su detalle.</T>,
      },
    ],
  },
  {
    id: 'pedidos',
    icon: '🛵',
    label: <T>Pedidos de comida y súper</T>,
    questions: [
      {
        q: <T>¿Cómo hago un pedido?</T>,
        a: <T>Entra a "Pedidos", elige un restaurante o súper y agrega productos al carrito. Elige envío o retiro, deja tu dirección (si es con envío) y un teléfono, selecciona la forma de pago y confirma. Puedes seguir el estado desde "Mis pedidos".</T>,
      },
      {
        q: <T>¿Cómo se pagan los pedidos?</T>,
        a: <T>En efectivo o por transferencia, si el local la acepta, directamente al local: no se pagan con PayPal ni con tarjeta dentro de la app. Si eliges transferencia, verás el monto y el alias en el detalle del pedido cuando el local lo acepte. Cada local define sus precios, su moneda, el pedido mínimo y el costo de envío.</T>,
      },
      {
        q: <T>¿Para qué sirve el código de entrega?</T>,
        a: <T>Es un código de 4 números que aparece en el detalle de tu pedido. Díselo al repartidor o al local recién cuando recibas el pedido, porque sin ese código no se puede marcar como entregado.</T>,
      },
      {
        q: <T>¿Puedo seguir mi pedido en el mapa?</T>,
        a: <T>En los pedidos con envío, el detalle muestra un mapa con el local y el destino. Si el local comparte su ubicación, también verás al repartidor mientras el pedido está en camino. El envío lo hace cada local, no Notiline.</T>,
      },
      {
        q: <T>¿Cómo cancelo un pedido o pido un reembolso?</T>,
        a: <T>Puedes cancelarlo desde el detalle del pedido mientras el local no lo haya aceptado; después tienes que hablar con el local. Como el pago va directo al local, Notiline no recibe ese dinero y no puede reembolsarlo: si ya transferiste y hubo un problema, pídele la devolución al local. También puedes avisarnos a support@notiline.com para que revisemos el caso.</T>,
      },
      {
        q: <T>¿Cómo sumo mi restaurante o súper?</T>,
        a: <T>Entra a "Pedidos" y toca "Sumá tu local". Necesitas una suscripción activa, y el mes gratis también sirve. Carga los datos del local, los horarios y los productos. Los pedidos te llegan a "Mi local", donde los aceptas, actualizas su estado y confirmas la entrega con el código que te da el cliente.</T>,
      },
      {
        q: <T>¿Cuánto cuesta tener un local en Pedidos?</T>,
        a: <T>Está incluido en todos los planes, sin costo adicional, y hoy Notiline no cobra comisión sobre los pedidos. Solo necesitas mantener una suscripción activa.</T>,
      },
      {
        q: <T>¿Qué pasa con mi local cuando termina el mes gratis o mi plan?</T>,
        a: <T>Tu local deja de aparecer en Pedidos y no recibe pedidos nuevos, pero conservas el menú y puedes terminar desde "Mi local" los pedidos que ya tenías en curso. Te avisamos unos días antes de que termine el mes gratis. Cuando eliges un plan, tu local vuelve a aparecer solo.</T>,
      },
    ],
  },
  {
    id: 'pagosqr',
    icon: '📱',
    label: <T>Pagos con código QR</T>,
    questions: [
      {
        q: <T>¿Cómo cobro a un cliente con código QR?</T>,
        a: <T>Desde "Generar QR de cobro" selecciona las ofertas o productos que el cliente va a pagar; la app genera un código QR con el monto total para que el cliente lo escanee.</T>,
      },
      {
        q: <T>¿Cómo pago escaneando un código QR?</T>,
        a: <T>Usa la opción "Escanear QR", apunta la cámara al código que te muestra el vendedor y confirma el pago de los productos u ofertas seleccionados.</T>,
      },
    ],
  },
  {
    id: 'chats',
    icon: '💬',
    label: <T>Chats y Mensajes</T>,
    questions: [
      {
        q: <T>¿Cómo contacto a un vendedor o a otro usuario?</T>,
        a: <T>Desde el detalle de una publicación (oferta, auto, propiedad, etc.) o desde el perfil de un usuario puedes pulsar "Mensaje" para abrir un chat directo con esa persona.</T>,
      },
      {
        q: <T>¿Dónde veo todas mis conversaciones?</T>,
        a: <T>En la sección "Chats", organizada en pestañas: Todos, Directos, Autos y Lugares. Los chats de Autos y Lugares quedan vinculados a la publicación desde la que escribiste; los Directos son conversaciones persona a persona.</T>,
      },
    ],
  },
  {
    id: 'notificaciones',
    icon: '🔔',
    label: <T>Notificaciones</T>,
    questions: [
      {
        q: <T>¿Qué notificaciones recibo?</T>,
        a: <T>Recibes avisos de nuevos mensajes en tus chats, nuevas ofertas y nuevos eventos publicados por las cuentas que sigues, y de los cambios de estado de tus pedidos. Si tienes un local, también te avisamos de cada pedido nuevo.</T>,
      },
      {
        q: <T>¿Cómo desactivo o ajusto mis notificaciones?</T>,
        a: <T>Ve a Ajustes → Notificaciones para activar o desactivar cada tipo de aviso según lo que prefieras recibir.</T>,
      },
    ],
  },
];

export default supportFaqData;